/**
 * 右键菜单 / 子菜单的统一外观，与工具栏、弹层一致的「新 UI」风格
 * （fm-toolbar-surface + sidebar 玻璃拟态 + 大圆角）。
 * 用于画布右键菜单与节点右键菜单，保持与其它浮层一致。
 */
export const FM_CONTEXT_MENU_SURFACE =
  "fm-toolbar-surface bg-sidebar/95 backdrop-blur-2xl border border-sidebar-border shadow-none rounded-2xl p-1.5 [&_[data-slot=context-menu-item]]:rounded-lg [&_[data-slot=context-menu-sub-trigger]]:rounded-lg";

/**
 * Shared surface for Radix dropdown menus / submenus inside the canvas panels
 * (filter menus, row "…" menus, "Move to" submenus). Compose with width / max
 * height utilities per call site, e.g. `cn(FM_DROPDOWN_SURFACE, 'w-44')`.
 */
export const FM_DROPDOWN_SURFACE =
  "fm-toolbar-surface rounded-2xl border border-sidebar-border/30 bg-sidebar/95 p-1.5 shadow-2xl backdrop-blur-2xl";
